import { falAngleLeft } from 'shared/@generated/icons/falAngleLeft';
import { falAngleRight } from 'shared/@generated/icons/falAngleRight';
import { GestureResponderEvent, TouchableOpacity } from 'react-native';
import { Icon } from 'shared/components/icon';

type GalleryArrowButtonSize = 'default' | 'compact';
type GalleryArrowButtonAppearance = 'default' | 'overlay';

type GalleryArrowButtonProps = {
  direction: 'previous' | 'next';
  hideOnMobile?: boolean;
  size?: GalleryArrowButtonSize;
  appearance?: GalleryArrowButtonAppearance;
  onPress: (event: GestureResponderEvent) => void;
  testID?: string;
};

const GalleryArrowButton = ({
  direction,
  hideOnMobile = false,
  size = 'default',
  appearance = 'default',
  onPress,
  testID,
}: GalleryArrowButtonProps) => {
  const isPrevious = direction === 'previous';
  const sizeClassName =
    size === 'compact'
      ? 'size-9'
      : appearance === 'overlay'
        ? 'size-10 md:size-12'
        : 'size-12 md:size-14';
  const iconClassName =
    size === 'compact'
      ? 'size-5'
      : appearance === 'overlay'
        ? 'size-5 md:size-6'
        : 'size-6 md:size-7';
  const positionClassName =
    size === 'compact'
      ? isPrevious
        ? 'left-2'
        : 'right-2'
      : isPrevious
        ? 'left-2 md:left-3'
        : 'right-2 md:right-3';
  const appearanceClassName =
    appearance === 'overlay'
      ? 'pointer-events-auto rounded bg-black/20 text-white hover:bg-black/35'
      : 'shadow-brand-brown-dark/15 hover:bg-brand-cream-light pointer-events-none rounded-full bg-white shadow group-hover:pointer-events-auto';

  return (
    <TouchableOpacity
      accessibilityLabel={isPrevious ? 'Previous media' : 'Next media'}
      accessibilityRole={'button'}
      activeOpacity={0.75}
      className={`focus-visible:ring-brand-green absolute top-1/2 z-20 -translate-y-1/2 items-center justify-center transition-colors focus:outline-none focus-visible:ring-2 ${appearanceClassName} ${sizeClassName} ${hideOnMobile ? 'hidden md:flex' : 'flex'} ${positionClassName}`}
      onPress={onPress}
      testID={testID}
    >
      <Icon
        icon={isPrevious ? falAngleLeft : falAngleRight}
        className={`${appearance === 'overlay' ? 'text-white' : 'text-brand-brown-dark'} ${iconClassName}`}
      />
    </TouchableOpacity>
  );
};

export { GalleryArrowButton };
